import { render } from "./StartFlow.vue?vue&type=template&id=f4c6af1c"
import script from "./StartFlow.vue?vue&type=script&lang=js"
export * from "./StartFlow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__